import chatList from './chatList.hbs';
import './chatList.scss'

const chats = [
  {
    "title": "Константин Константинович Константинов",
    "lastMessage": "Круто!",
    "date": "12 Апр 2020",
    "badge": "32"
  },
  {
    "title": "Андрей",
    "lastMessage": "Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться. Lorem Ipsum используют потому, что тот обеспечивает более или менее стандартное заполнение шаблона",
    "date": "Пт",
    "badge": ""
  },
  {
    "title": "тет-а-теты",
    "lastMessage": "Lorem Ipsum",
    "date": "12:00",
    "badge": "12"
  },
  {
    "title": "1, 2, 3",
    "lastMessage": "Многие думают, что Lorem Ipsum - взятый с потолка псевдо-латинский набор слов, но это не совсем так.",
    "date": "12 Апр 2020",
    "badge": "1"
  },
  {
    "title": "Design Destroyer",
    "lastMessage": "Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться. Lorem Ipsum используют потому, что тот обеспечивает более или менее стандартное заполнение шаблона",
    "date": "01 Апр 2021",
    "badge": ""
  },
  {
    "title": "Day.",
    "lastMessage": "Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться. Lorem Ipsum используют потому, что тот обеспечивает более или менее стандартное заполнение шаблона",
    "date": "15 Апр 2020",
    "badge": ""
  },
  {
    "title": "Стас Рогозин",
    "lastMessage": "Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться. Lorem Ipsum используют потому, что тот обеспечивает более или менее стандартное заполнение шаблона",
    "date": "12 Апр 2020",
    "badge": "32"
  },
  {
    "title": "Илья",
    "lastMessage": "Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться. Lorem Ipsum используют потому, что тот обеспечивает более или менее стандартное заполнение шаблона",
    "date": "Ср",
    "badge": "1"
  },
  {
    "title": "Киноклуб",
    "lastMessage": "Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться. Lorem Ipsum используют потому, что тот обеспечивает более или менее стандартное заполнение шаблона",
    "date": "Пн",
    "badge": ""
  },
  {
    "title": "Стас Рогозин",
    "lastMessage": "Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться. Lorem Ipsum используют потому, что тот обеспечивает более или менее стандартное заполнение шаблона",
    "date": "12 Апр 2020",
    "badge": "32"
  },
  {
    "title": "Илья",
    "lastMessage": "Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться. Lorem Ipsum используют потому, что тот обеспечивает более или менее стандартное заполнение шаблона",
    "date": "Ср",
    "badge": "1"
  },
  {
    "title": "Киноклуб",
    "lastMessage": "Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться. Lorem Ipsum используют потому, что тот обеспечивает более или менее стандартное заполнение шаблона",
    "date": "Пн",
    "badge": ""
  },
]

export default () => chatList({chats})
